import { useState } from "react";

const useTagFilter = () => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [isAllSelected, setIsAllSelected] = useState<boolean>(true);

  const handleFilterClick = (val: string) => {
    setIsAllSelected(false);
    if (selectedFilters.includes(val)) {
      const filteredTags = selectedFilters?.filter((v) => v !== val) ?? [];
      setSelectedFilters(filteredTags);
    } else {
      setSelectedFilters([...selectedFilters, val]);
    }
  };

  const handleFilterSelection = (val: string[]) => {
    setSelectedFilters(val);
  };

  const resetTagFilter = () => {
    setIsAllSelected(true);
    setSelectedFilters([]);
  };

  const handleAllSelection = () => {
    if (isAllSelected) {
      setIsAllSelected(false);
    } else {
      setIsAllSelected(true);
    }
    setSelectedFilters([]);
  };

  return {
    selectedFilters,
    isAllSelected,
    handleFilterSelection,
    handleFilterClick,
    resetTagFilter,
    handleAllSelection,
  };
};
export default useTagFilter;
